exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app #payment[data-v-ddc6f3a2]{background:#f6f6f6;height:100vh}#app .payment-container[data-v-ddc6f3a2]{margin-top:7em}", ""]);

// exports
